import { useCallback, useReducer } from 'react'
import { produce } from 'immer'
import { FormState, FormAction } from '../typings'
import { locationToFormModel } from '@user/components/Location'

function reducer(state: FormState, action: FormAction): FormState {
  switch (action.type) {
    case 'edit':
      return produce(state, (draft) => {
        draft.open = true
        draft.initialValues = locationToFormModel(action.payload)
        draft.isBillingLocation = action.payload.billingLocation
      })
    case 'close':
      return produce(state, (draft) => {
        draft.open = false
        draft.initialValues = undefined
      })
  }
}

export function useEditLocation() {
  const [state, dispatch] = useReducer(reducer, {
    isBillingLocation: false,
    open: false,
  })

  const onClose = useCallback(() => dispatch({ type: 'close' }), [])

  return [state, dispatch, onClose] as const
}
